export default __webpack_public_path__ + "static/media/Mask Group 142.b1af0c3a.svg";